import React, { useEffect, useContext } from "react";
import { ArtContext } from "../Contexts/ArtContext";
import Loading from "../pages/Loading";
import Aos from "aos";
import "aos/dist/aos.css";
import { usePayment } from "../Contexts/PaymentContext";

const Cta = () => {
  const { arts, fetchRecentArts, loading } = useContext(ArtContext);
  const { createInvoiceAndPay, isProcessing, buttonText } = usePayment();

  useEffect(() => {
    Aos.init({ duration: 100 });
    Aos.refresh();
    fetchRecentArts();
  }, []);

  return (
    <div className="">
      {/* The Studio Section */}
      <div className="bg-primary text-gray-50 py-28 lg-custom:py-32 px-6 lg-custom:px-8 flex flex-col lg-custom:flex-row lg-custom:justify-center lg-custom:items-center text-cente lg-custom:text-left">
        <div className="flex justify-center lg-custom:justify-start w-full lg-custom:w-1/2">
          <div
            className="lg-custom:w-full mb-8 lg-custom:mb-0 lg-custom:ml-20"
            data-aos="fade-up"
            data-aos-duration="500"
          >
            <h2 className="text-4xl lg-custom:text-6xl font-bold mb-4 ml-2 lg-custom:ml-10">
              The Studio
            </h2>
            <p className="mb-4 demfont lg-custom:text-2xl tracking-wide py-2 px-2 lg-custom:px-10">
              Founded in Musanze, Rwanda, in 2023, the studio aims to foster a
              community of artists where they can express themselves freely,
              connect with peers, and explore their potential while deepening
              their understanding of wildlife.
            </p>
            <div className="flex justify-cente lg-custom:justify-start">
              <a href="/about-sawa">
                <button className="bg-white text-primary font-bold font-poppins lg-custom:py-3 py-2 text-lg lg-custom:text-2xl px-4 rounded-lg mt-4 flex items-center ml-2 lg-custom:ml-10">
                  Our Story <span className="ml-2 mt-1 font-bold">{">"}</span>
                </button>
              </a>
            </div>
          </div>
        </div>
        <div
          className="lg-custom:w-1/2 flex mt-4"
          data-aos="fade-up"
          data-aos-duration="500"
        >
          <img
            src="https://res.cloudinary.com/duchitv8b/image/upload/w_auto,q_auto/f_auto/c_limit,w_2000/sqxjudil8bfiiutoquen.webp"
            alt="The Studio"
            className="w-5/6 h-auto rounded-md"
          />
        </div>
      </div>
      {/* New Releases Section */}
      <div className="py-8 px-4 md:px-16 lg:px-24 mt-8">
        <div className="flex flex-col md:flex-row justify-between items-center mb-8">
          <h2 className="text-3xl md:text-4xl lg:text-6xl ml-0 md:ml-4 mb-4 md:mb-0">
            New Releases
          </h2>
          <a
            href="/shop"
            className="hidden md:block text-black underline text-lg md:text-xl lg:text-2xl font-semibold underline-offset-8 decoration-1"
          >
            View all
          </a>
        </div>
        {loading ? (
          <Loading />
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {arts.map((artwork) => (
              <div className="text-black p-4 rounded-lg" key={artwork._id}>
                <a href={`/product/${artwork._id}`}>
                  <img src={`${artwork.artImageCover}`} alt={artwork.artName} />
                </a>
                <h4 className="text-2xl font-semibold tracking-wide pt-3">
                  {artwork.artName}
                </h4>
                <p className="text-1xl font-light">
                  ${artwork.editions[0].price}
                </p>
              </div>
            ))}
          </div>
        )}
        <div className="flex justify-center mt-4 md:hidden">
          <a
            href="/shop"
            className="text-black underline text-lg md:text-xl lg:text-2xl font-semibold underline-offset-8 decoration-1"
          >
            View all
          </a>
        </div>
      </div>
      {/* Our artists section */}
      <div className="relative h-screen flex items-center justify-center md:justify-end">
        <img
          src="https://res.cloudinary.com/duchitv8b/image/upload/f_auto,q_auto/zuigwzkd4t1xvjcccsi7"
          alt="Artist"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black opacity-50"></div>
        <div className="relative z-10 max-w-3xl text-white p-4 sm:p-8 md:p-16">
          <p
            className="mb-4 text-lg sm:text-xl md:text-2xl lg:text-3xl"
            data-aos="fade-up"
            data-aos-duration="1000"
          >
            We are a collective of artists united by a shared passion to
            redefine perceptions of wildlife through art. Our group comprises
            both male and female artists who practice various art forms,
            including painting and sculpture.
          </p>
          <a href="/about-artists">
            <button
              data-aos="zoom-out-left"
              data-aos-duration="1000"
              className="bg-secondary text-white font-bold py-2 text-base sm:text-lg md:text-3xl px-4 rounded-lg mt-10 flex items-center"
            >
              Our Artists <span className="ml-2 mt-1 font-bold">{">"}</span>
            </button>
          </a>
        </div>

        <div class="second-gradient-overlay"></div>
      </div>

      {/* Our services section */}
      <section className="bg-black text-gray-50 py-28 px-6 lg:py-30 lg:px-20">
        <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div
            className="px-4 lg:px-8"
            data-aos="fade-up"
            data-aos-duration="700"
          >
            <h3 className="text-3xl text-secondary font-bold mb-6 lg:mb-20">
              Services
            </h3>
            <h2 className="text-4xl lg:text-6xl mb-4">
              The Artful <br />
              Solutions
            </h2>
            <p className="mb-4 text-lg lg:text-2xl demfont tracking-wide pt-5 demline">
              From providing a dedicated workspace for your creative endeavors
              to teaching art techniques and preserving your artwork, we have
              you covered. Whether you're looking to rent our studio, take a
              class, frame your masterpiece, or commission a custom piece.
            </p>
            <a href="/services">
              <button className="bg-white text-black font-bold font-poppins py-3 text-lg lg:text-2xl px-4 rounded-lg mt-6 lg:mt-10 flex items-center">
                View All <span className="ml-2 mt-1 font-bold">{">"}</span>
              </button>
            </a>
          </div>
          <div
            className="px-4 lg:px-8"
            data-aos="fade-down"
            data-aos-duration="900"
          >
            <img
              src="https://res.cloudinary.com/duchitv8b/image/upload/f_auto,q_auto/gfcitnh7qmtcevvb16hz"
              alt="Artist in studio"
              className="w-full h-auto rounded-xl"
            />
          </div>
        </div>
      </section>
      <section>
        <div className="relative h-screen flex items-center justify-center text-center">
          <img
            src="https://res.cloudinary.com/duchitv8b/image/upload/w_auto,q_auto,f_auto/c_limit,w_1000/rnfaeljiyjzjds1h0ihp.webp"
            alt="Artist"
            className="absolute inset-0 w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black opacity-70"></div>
          <div className="relative z-10 flex flex-col items-center max-w-full text-gray-50 p-4 md:p-8">
            <h2
              className="mb-4 text-4xl md:text-6xl font-bold"
              data-aos="fade-out"
              data-aos-duration="1000"
            >
              Book Your Visit Today
            </h2>
            <p
              className="mb-4 text-lg md:text-2xl demfont px-0 md:px-16 w-4/5 mx-auto mt-3 demline"
              data-aos="fade-out"
              data-aos-duration="1000"
            >
              SAWA requests that visitors book their visits in advance to
              support their artists and ensure a positive experience for
              everyone. Booking fees help artists focus on their creative
              pursuits without worrying about immediate sales.
            </p>
            <button
              className="bg-secondary text-white font-bold font-poppins py-3 text-lg lg:text-2xl px-4 rounded-lg mt-6 lg:mt-10 flex items-center"
              onClick={createInvoiceAndPay}
              disabled={isProcessing}
            >
              {buttonText}
              {/* Book Now */}
            </button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Cta;
